import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2 } from "lucide-react";

const benefits = [
  "Close your day in under 2 minutes",
  "Catch cash mismatches immediately",
  "Track every rupee of profit",
  "Manage multiple team members",
  "Export reports for loans",
  "AI-powered business insights"
];

interface BenefitsSectionProps {
  user: any;
  onGetStarted: () => void;
}

export const BenefitsSection = ({ user, onGetStarted }: BenefitsSectionProps) => {
  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 gradient-mesh opacity-50" />
      
      <div className="container relative z-10 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden">
            {/* Glow effect */}
            <div className="absolute -inset-1 bg-gradient-to-r from-primary via-accent to-primary rounded-2xl md:rounded-3xl blur-lg opacity-20" />
            
            <div className="relative glass rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-12 lg:p-16">
              <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
                {/* Left content */}
                <div className="space-y-4 md:space-y-6 text-center lg:text-left">
                  <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-balance">
                    Why Business Owners
                    <span className="text-gradient"> Love KOSH</span>
                  </h2>
                  <p className="text-base md:text-lg text-muted-foreground">
                    Join thousands of small business owners who trust KOSH to manage their daily operations.
                  </p>
                  <Button 
                    size="lg" 
                    onClick={onGetStarted}
                    className="group text-base md:text-lg h-12 md:h-14 px-8 md:px-10 rounded-full bg-gradient-to-r from-primary to-primary-dark hover:from-primary-dark hover:to-primary shadow-lg shadow-primary/25 w-full sm:w-auto"
                  >
                    {user ? "Go to Dashboard" : "Get Started Now"}
                    <ArrowRight className="ml-2 h-4 w-4 md:h-5 md:w-5 group-hover:translate-x-1 transition-transform" />
                  </Button>
                </div>

                {/* Right content - benefits list */}
                <div className="space-y-3 md:space-y-4">
                  {benefits.map((benefit, index) => (
                    <div 
                      key={index}
                      className="flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-xl md:rounded-2xl bg-card/50 border border-border/50 hover:border-primary/30 transition-colors"
                    >
                      <div className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-gradient-to-br from-primary to-primary-dark flex items-center justify-center flex-shrink-0">
                        <CheckCircle2 className="h-4 w-4 md:h-5 md:w-5 text-primary-foreground" />
                      </div>
                      <span className="text-sm md:text-base font-medium">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};